import React, { useState } from 'react';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import './AutoPairModal.scss';
import { useUser } from 'hooks/useUser';
import breakerplaceholder from '../../assets/img/breaker-placeholder.png';
import { useEggContext } from 'contexts/EggContext';
import { autoPairEgg } from 'utils/PointsAPI';
import Spinner from 'components/Spinner';

export const AutoPairModal = ({ onClose }: any) => {
  const { account } = useUser();
  const breakers = account.breakers;
  const { data } = useEggContext();
  const eggs = data?.eggs;
  const [isLoading, setIsLoading] = useState(false);

  const pairEggs = async (strongest: boolean) => {
    if (account.dusktech?.userId) {
      setIsLoading(true);
      await autoPairEgg(account.dusktech.userId, strongest);
      onClose();
    }
  };
  return (
    <div className="modal fade show auto-pair-modal" tabIndex={-1} id="auto-pair-modal">
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="auto-pair-modal-header">
            <h3>Auto Pair</h3>
            <button
              type="button"
              className="btn-close btn-close-white close-modal-btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
            />
          </div>
          <div className="auto-pair-modal-body">
            <div className="auto-pair-modal-egg">
              <img
                src={breakers[0].imageUrls.thumbnail}
                alt="Breaker"
                className="auto-pair-breaker-img"
              />
              <HorizontalDivider className="horizontal-divider-first-breaker" />
              <img src="/egg_assets/static/LV3_3.png" alt="Egg" className="auto-pair-egg-img" />

              <HorizontalDivider className="horizontal-divider-second-breaker" />
              <img
                src={breakers[1]?.imageUrls.thumbnail || breakerplaceholder}
                alt="Breaker"
                className="auto-pair-breaker-img"
              />
            </div>
            <div className="auto-pair-action">
              {eggs && (
                <p className="auto-pair-count m-0">
                  {breakers.length} BREAKER(S) &rarr; {eggs.length} EGG(S)
                </p>
              )}
              <p className="auto-pair-warning m-0 mb-2">
                This action will remove your current pairs
              </p>
              {isLoading && (
                <Spinner color="white" width={20} height={20} className="breaker-pair-spinner" />
              )}
              {!isLoading && (
                <>
                  <button className="btn btn-secondary btn-sm" onClick={() => pairEggs(true)}>
                    Pair strongest eggs
                  </button>
                  <button className="btn btn-secondary btn-sm" onClick={() => pairEggs(false)}>
                    Pair weakest eggs
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};
